module.exports = __webpack_public_path__ + "static/media/IMG_9722.dfbbcb61.mp4";